import { render } from "./WaveBoard.vue?vue&type=template&id=162da242&scoped=true"
import script from "./WaveBoard.vue?vue&type=script&lang=js"
export * from "./WaveBoard.vue?vue&type=script&lang=js"

import "./WaveBoard.vue?vue&type=style&index=0&id=162da242&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162da242"]])

export default __exports__